import { NextSeo } from "next-seo"
import type { ReactElement } from "react"
import * as React from "react"

import Footer from "@/components/common/Layout/Footer"
import { Layout } from "@/components/common/Layout/Layout"
import Hero from "@/components/HomePage/Hero"
import HowItWorks from "@/components/HomePage/HowItWorks"
import NewsletterSubscription from "@/components/HomePage/NewsletterSubscription"
import Offering from "@/components/HomePage/Offering"
import { Services } from "@/components/Services"
import { ServicesHeading } from "@/components/Services/heading"

import type { GetPageLayout } from "@/pages/_app"

class HomePage extends React.PureComponent {
  static getPageLayout = ({ page }: GetPageLayout): React.ReactElement => {
    return (
      <>
        <NextSeo
          titleTemplate={`WellNow | %s`}
          title={`Find a New Zealand Practitioner | Book Online`}
          description={`Find and book last minute health and wellness appointments on WellNow.`}
          canonical={`${process.env.NEXT_PUBLIC_WELLNOW_HOST}`}
          openGraph={{
            title: `WellNow | Find a New Zealand Practitioner | Book Online`,
            url: `${process.env.NEXT_PUBLIC_WELLNOW_HOST}`,
            description: `Find and book last minute health and wellness appointments on WellNow.`,
          }}
        />
        <Layout className={`bg-primary-50 pt-0 pb-0 sm:pt-0 md:pt-0`}>
          {page}
          <Footer />
        </Layout>
      </>
    )
  }

  public render = (): ReactElement => {
    return (
      <main className={`bg-primary-50`}>
        <NextSeo
          titleTemplate={`WellNow | %s`}
          title={`Find a New Zealand Practitioner | Book Online`}
          description={`Find and book last minute health and wellness appointments on WellNow.`}
          canonical={`${process.env.NEXT_PUBLIC_WELLNOW_HOST}`}
          openGraph={{
            url: `${process.env.NEXT_PUBLIC_WELLNOW_HOST}`,
            title: `WellNow | Find a New Zealand Practitioner | Book Online`,
            description: `Find and book last minute health and wellness appointments on WellNow.`,
          }}
        />
        <Hero />
        <Offering />
        <HowItWorks />
        <ServicesHeading />
        <Services />
        <NewsletterSubscription />
      </main>
    )
  }
}

export default HomePage
